import * as angular from 'angular';
import * as React from 'react';
import {LineEquipmentTab} from "../../models/counts/lineCounts";

class CountDetailComponent extends React.Component<LineEquipmentTab, LineEquipmentTab> {
  componentDidMount() {
    this.setState(this.props);
    this.props.counts.onUpdated.push(() => this.setState(this.props));
  }

  render(): JSX.Element {
    if (!this.state) {
      return React.createElement('div', {key: 'main', className: 'er-data'});
    }

    let tab = this.state;
    let rows = [];
    rows.push(this.createHeader(tab));
    rows.push(this.createBody(tab));

    return React.createElement('div', {key: 'main', className: 'er-data'},
      React.createElement('table', {key: 'table', className: 'er-table'}, rows)
    );
  }

  private createHeader(tab: LineEquipmentTab): JSX.Element {
    let columns = [];
    let className = !tab.showHeader ? 'er-spacer' : undefined;
    let width = '5em';
    if (!tab.hideRowColumn) {
      if (tab.rowColumnWidthEm) {
        width = `${tab.rowColumnWidthEm}em`;
      }
      columns.push(React.createElement('th', {
          key: 'rowColumn',
          className: className,
          style: {width: width}
        }, tab.showHeader ? tab.rowHeader || ' ' : ' '));
    }
    tab.columns.forEach((column, i) => {
      className = undefined;
      if (!tab.showHeader) {
        className = 'er-spacer';
      } else if (tab.outputRows[0].cells[i].rightJustify) {
        className = 'rightJustify';
      }
      width = '5em';
      if (column.widthEm) {
        width = `${column.widthEm}em`;
      }
      columns.push(React.createElement('th', {
          key: 'column' + i,
          className: className,
          style: {width: width}
        }, tab.showHeader ? column.name : ' '));
      className = 'rightJustify';
      if (column.showPercent) {
        columns.push(React.createElement('th', {
          key: 'columnP' + i,
          className: className,
          style: {width: '5em'}
        }));
      }
      if (column.showTrend) {
        columns.push(React.createElement('th', {
          key: 'columnT' + i,
          className: className,
          style: {width: '3em'}
        }));
      }
    });
    return React.createElement('thead', {key: 'head'},
      React.createElement('tr', {key: 'headTr', className: 'count-header'}, columns)
    );
  }

  private createBody(tab: LineEquipmentTab): JSX.Element {
    let rows = [];
    tab.outputRows.forEach(row => {
      let cells = [];
      if (!tab.hideRowColumn) {
        if (row.displayName === "9999"){
           row.displayName = "MNR";
        }
        cells.push(React.createElement('td',
          {key: 'rowColumn', className: 'er-spacer'},
          row.displayName));
      }
      let createRow = true;
      if (row.cells) {
        row.cells.forEach((cell, i) => {
          let value = cell.fixedValue;
          if (!cell.isFixed && cell.count && cell) {
            if (row.isNoCount) {
              value = 'NC';
            } else {
              value = cell.count.count.toFixed(0);
            }
          }

          let options = {key: `${row.id}-${i}`, className: undefined};
          if (cell.rightJustify) {
            options.className = 'rightJustify';
          }

          cells.push(React.createElement('td', options, value));

          if (cell.count) {
            if (cell.count.showPercent) {
              let percent = '';
              if (!row.isNoCount) {
                percent = cell.count.getPercent() + '%';
                if (cell.count.count === 0){
                  createRow = false;
                }
              }
              cells.push(React.createElement('td',
                {key: `${row.id}-p${i}`, className: 'rightJustify'},
                percent));
            }

            if (cell.count.showTrend) {
              let trend: any = '';
              if (!row.isNoCount) {
                let trendClass = 'trend';
                if (cell.count.trend && cell.count.trend.down) {
                  trendClass += ' trend-down';
                } else if (cell.count.trend && cell.count.trend.up) {
                  trendClass += ' trend-up';
                }
                trend = React.createElement('i', {className: trendClass}, '');
              }
              cells.push(React.createElement('td',
                {key: `${row.id}-t${i}`},
                trend));
            }
          }
        });
      }
      if (createRow){
      rows.push(React.createElement('tr', {
        key: row.id,
        className: row.isChild ? 'sub-count-detail-row'
          : (row.headerRow ? 'count-header-row' : 'count-detail-row')
      }, cells));
    }
    });
    return React.createElement('tbody', {key: 'body'}, rows);
  }
}

export default angular.module('aps.controller.countDetail', [])
  .factory('CountDetailComponent', () => {
    return CountDetailComponent;
  })
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/counts/countDetail.ts